
import _ from 'lodash';
import React, { Component } from 'react';
import Chip from '@material-ui/core/Chip';
import { InputAdornment, IconButton } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import styled from "styled-components";
import { withAsync } from './withAsync';


const StyledInputAdornment = styled(InputAdornment)`
  top: calc(50% - 14px);
  position: absolute;
  right: 65px;
  height: 28px;
`;

const StyledAutocomplete = styled(Autocomplete)`
  .MuiInputBase-root {
    padding-right: 90px !important;
  }
`;


class AutocompleteMultipleWidget extends Component {

  static defaultProps = {
    optionLabel: 'name',
    showSelectAllOptionsButton: true,
    filterSelectedOptions: true,
    shrink: true
  };

  handleChange = (e, newValue) => {
    const { onChange } = this.props;
    let values = [];
    if (newValue && _.isArray(newValue)) {
      newValue.forEach(value => values.push(value.id));
    }
    onChange(newValue, values);
  };

  getOptionLabel = (option) => {
    const { optionLabel } = this.props;
    if (option && option[optionLabel]) {
      return option[optionLabel];
    }
    return '';
  };

  handleOptionSelected = (option, value) => {
    return option.id === value.id;
  };

  addAllOptions = (e) => {
    const { options } = this.props;
    this.handleChange(e, options);
  }

  render() {
    const { options, loading, value, label, placeholder, showSelectAllOptionsButton, limitTags, size, renderOption, filterSelectedOptions, shrink } = this.props;
    return (
      <StyledAutocomplete
        multiple
        options={options}
        loading={loading}
        value={value}
        getOptionSelected={this.handleOptionSelected}
        getOptionLabel={(option) => this.getOptionLabel(option)}
        filterSelectedOptions={filterSelectedOptions}
        onChange={(e, newValue) => this.handleChange(e, newValue)}
        limitTags={limitTags}
        fullWidth={true}
        renderOption={renderOption}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip color="primary" size={size} label={this.getOptionLabel(option)} {...getTagProps({ index })} />
          ))
        }
        renderInput={(params) => {
          params.InputProps['endAdornment'] =
            <>
              {params.InputProps['endAdornment']}
              {showSelectAllOptionsButton && (
                <StyledInputAdornment position="end">
                  <IconButton onClick={(e) => this.addAllOptions(e)} size={'small'}>
                    <DoneAllIcon />
                  </IconButton>
                </StyledInputAdornment>
              )}
            </>
          return (
            <TextField
              {...params}
              variant="outlined"
              label={label}
              placeholder={placeholder}
              size={size}
              InputLabelProps={{ shrink: shrink }}
            />
          )
        }}
      />
    )
  }
}

export const AsyncAutocompleteMultipleWidget = withAsync(AutocompleteMultipleWidget);
